import { lazy } from 'react'

import ConnectionLoader from './loader'

export default {
  Connection: {
    Component: lazy(() => import('./Connection.Page')),
    Loader: ConnectionLoader,
  },
}
